import store from '../../store'
import PGSHelper from '../../helpers/PGSHelper.js';

export default class PeriodosCobro {
    static typeSearch      = "local" //online || local
    static rules           = {
        Nombre:[(value) => !!value || "El nombre es obligatorio"],
        Pagos: [(value) => !!value || "El numero de pagos obligatorio"],
        Prorroga: [(value) => !!value || "Los Días de prorroga son obligatorios"],
        Periodos:[(value)=>!!value || "Los Días de prorroga son obligatorios"]
    }
    constructor(data = null) {
        this.Nombre        = (data?.Nombre)?data.Nombre:'';
        this.Id            = (data?.Id)?data.Id:null;
        this.Pagos         = (data?.Pagos)?data.Pagos:1;
        this.Prorroga      = (data?.Prorroga)?data.Prorroga:1;
        this.Periodos      = (data?.Periodos)?data.Periodos:1;
    }

    static getPropertyModel(){
        let model = new PeriodosCobro();
        return model;
    }

    static getTiposPagos(){
      return [
        {text:"Pago Anual (1 Pago)",value:1},
        {text:"Pago Semestral (2 Pagos)",value:2},
        {text:"Pago Mensual (12 Pago)",value:12},
        {text:"Pago Quincenal (24 Pago)",value:24},
      ];
    }

    static getById(id){
      let pgsHelper  = new PGSHelper();
      let datos = pgsHelper.getById(store.getters["dataLists/getMbsPeriodos"],'id',id);
      if(!datos){
          return false;
      }
      datos.Id = id;
      return new PeriodosCobro(datos);
  }

    static getPeriodosCobroList(){
      let periodos = [];
      let localData = store.getters["dataLists/getMbsPeriodos"];
      localData.forEach((element)=>{
        periodos.push(new PeriodosCobro({ Id: element.id, ...element }));
      })
      return periodos;
  }



}